<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="dispensers"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Výdejci</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer><v-dialog
          v-model="dialog"
          max-width="650"
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              @click="editedItem = defaultItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Přidat výdejce
            </v-btn>
          </template>
          <DispenserForm
            :item="editedItem"
            @data-saved="getDispensers"
            v-if="dialog"
          ></DispenserForm>
        </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDispensers">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DispenserForm from '../../forms/admin/DispenserForm'
export default {
  name: 'Dispensers',
  components: { DispenserForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        email: '',
        firstName: '',
        active: false
      },
      headers: [
        { text: 'Název', value: 'firstName' },
        { text: 'Login', value: 'email' },
        { text: 'Akce', value: 'actions' }
      ],
      dispensers: []
    }
  },
  methods: {
    initialize () {
      this.getDispensers()
    },
    getDispensers () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/roles/5')
        .then(response => {
          this.dispensers = this.keysToCamelCase(response.data)
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    toggleActive (item) {
      item.active = !item.active
      this.$http.patch(`/admin/users/${item.id}`, this.keysToSnakeCase(item))
        .then(response => {
          this.getDispensers()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
